
import { Component, Vue } from 'vue-property-decorator'
import { BModal, BButton, BForm, BFormGroup, BFormSelect, BFormCheckbox, BFormInput, BInputGroupAppend, BInputGroup } from 'bootstrap-vue'
import { namespace } from 'vuex-class'
import api from '@/api'
import { email } from 'vee-validate/dist/rules'
import { extend } from 'vee-validate'
import { VueRecaptcha } from 'vue-recaptcha'

extend('emailList', value => {
  if (email.validate(value.split(',').map((s: string) => s.trim()))) { return true }
  return 'Please provide valid emails.'
})

const currentModel = namespace('currentModel')
const globalValues = namespace('globalValues')

@Component({
  components: {
    BModal,
    BButton,
    BForm,
    BFormGroup,
    BFormSelect,
    BFormCheckbox,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    VueRecaptcha
  },
  watch: {
    visible: function (val) {
      (this as any).reCaptchaValid = (this as any).reCaptchaValid && val
    }
  }
})
export default class EmailModal extends Vue {
  public form = {
    name: null,
    email: null,
    subscribe: false,
    additionalemails: '',
    captchaResponse: '',
    message: ''
  };

  public visible = false;
  public showLoadingSpinner = false;
  public reCaptchaValid = false;
  public sitekey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;
  public socialShares = [
    {
      network: 'facebook',
      icon: 'fab fa-facebook-square'
    },
    {
      network: 'pinterest',
      icon: 'fab fa-pinterest'
    },
    // {
    //   network: 'houzz',
    //   icon: 'fab fa-houzz'
    // },
    {
      network: 'twitter',
      icon: 'fab fa-twitter'
    }
    // {
    //   network: 'instagram',
    //   icon: 'fab fa-instagram'
    // },
  ]

  @currentModel.State
  public configurationKey!: string

  @globalValues.Action
  public setNotification!: (message?: string) => void

  get baseLink() {
    return location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '')
  }

  get configuratorLink() {
    return this.baseLink + '/configurator/c/' + this.configurationKey
  }

  get renderLink() {
    return this.baseLink + '/configurator/render/' + this.configurationKey
  }

  get showEmailsError() {
    if (!this.form.additionalemails) { return false }
    return this.form.additionalemails.split(',').some(s => !this.validateEmail(s))
  }

  public getValidationState({ dirty, validated, valid }: { dirty: boolean; validated: boolean; valid: boolean }) {
    return dirty || validated ? valid : null
  }

  public getEmailsValidationState({ dirty, validated, valid }: { dirty: boolean; validated: boolean; valid: boolean }) {
    if (!this.form.additionalemails) { return null }
    return dirty || validated ? valid : null
  }

  private validateEmail(email: string) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    return re.test(String(email).trim().toLowerCase())
  }

  public copyLinkSuccess() {
    this.setNotification('Copied to clipboard!')
  }

  public copyLinkError() {
    this.setNotification('Press Ctrl+C to copy!')
  }

  public onSubmit() {
    if (!this.reCaptchaValid) {
      return false
    }

    this.showLoadingSpinner = true
    api
      .post('/configuration/' + this.configurationKey + '/share/', this.form)
      .then(() => {
        this.visible = false
        this.showLoadingSpinner = false
        this.reCaptchaValid = false
        this.setNotification('Email sent!')
      })
      .catch(() => {
        this.reCaptchaValid = false
        this.setNotification('Error while sending email')
      })

    return true
  }

  // Vue Clipboard plugin doesn't work in modals; check https://github.com/euvl/v-clipboard/issues/18 to see if it's resolved
  public copyToClipboard(value: string) {
    const el = document.createElement('textarea')
    el.addEventListener('focusin', e => e.stopPropagation())
    el.value = value
    document.body.appendChild(el)
    el.select()
    document.execCommand('copy')
    document.body.removeChild(el)
    this.copyLinkSuccess()
  }

  public verify(response: any) {
    this.form.captchaResponse = response
    this.reCaptchaValid = true
  }

  public error() {
    this.reCaptchaValid = false
    this.setNotification('Error while validating captcha')
  }

  public expired() {
    this.reCaptchaValid = false
  }
}
